import { render, staticRenderFns } from "./EditPropertiesPaymentComponent.vue?vue&type=template&id=164cdc8e"
import script from "./EditPropertiesPaymentComponent.vue?vue&type=script&lang=js"
export * from "./EditPropertiesPaymentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports